<template>
  <div>
    <BreadCrumb :breadCrumbList="breadCrumbList"></BreadCrumb>
  </div>
</template>

<script>
import BreadCrumb from '@/components/Shared/BreadCrumb/BreadCrumbTemplate'

export default {
  name: 'PointGroupCatalogBreadCrumb',
  components: { BreadCrumb },
  computed: {
    breadCrumbList() {
      return [{ title: '地点管理リスト', path: null }]
    },
  },
}
</script>

<style scoped></style>
